import type { PublicPageAdvertisement } from "../../services/api/dashboard";

export interface PublicPageStats {
  parentCount: number;
  activeNoticeCount: number;
  upcomingEventsCount: number;
  advertisements: PublicPageAdvertisement[];
}

export interface PublicPageSettings {
  parentCount?: number;
  activeNoticeCount?: number;
  upcomingEventsCount?: number;
  advertisements?: PublicPageAdvertisement[];
  [key: string]: unknown;
}

export interface PublicPageStatsUpdate {
  needsUpdate: boolean;
  updatedSettings: PublicPageSettings;
}

/**
 * Decides whether an organization's public-page stats/advertisements are
 * stale relative to the dashboard's current data, and builds the merged
 * settings object to persist if so. Pure — the caller does the actual
 * API call and user-object update.
 */
export function computePublicPageStatsUpdate(
  currentSettings: PublicPageSettings,
  newStats: PublicPageStats
): PublicPageStatsUpdate {
  // Check for null/undefined specifically, not falsy values (0 and [] are valid).
  const needsUpdate =
    currentSettings.parentCount === undefined ||
    currentSettings.parentCount === null ||
    currentSettings.activeNoticeCount === undefined ||
    currentSettings.activeNoticeCount === null ||
    currentSettings.upcomingEventsCount === undefined ||
    currentSettings.upcomingEventsCount === null ||
    currentSettings.advertisements === undefined ||
    currentSettings.advertisements === null ||
    currentSettings.parentCount !== newStats.parentCount ||
    currentSettings.activeNoticeCount !== newStats.activeNoticeCount ||
    currentSettings.upcomingEventsCount !== newStats.upcomingEventsCount ||
    JSON.stringify(currentSettings.advertisements || []) !==
      JSON.stringify(newStats.advertisements || []);

  if (!needsUpdate) {
    return { needsUpdate: false, updatedSettings: currentSettings };
  }

  return {
    needsUpdate: true,
    updatedSettings: { ...currentSettings, ...newStats },
  };
}
